module.exports = __webpack_public_path__ + "img/dashboard-footer-strip.9aa53bf7.png";